import React from "react";
import { Link } from "react-router-dom";
import { PORTRAITS, SITE_META } from "@/data/content";
import { CompassMark } from "@/components/CompassMark";

export const Hero = () => {
  return (
    <section
      data-testid="home-hero"
      className="relative overflow-hidden bg-ink-base"
      aria-label="Hero"
    >
      <div className="container-wide pt-12 md:pt-20 pb-24 md:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          {/* Left: identity + observation */}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-10">
              <CompassMark size={20} className="opacity-80" alt="" />
              <p className="eyebrow-gold">Quentin Young · {SITE_META.domain}</p>
            </div>

            <h1 className="display-serif text-[44px] sm:text-[64px] lg:text-[88px] xl:text-[104px] text-paper-primary leading-[0.95] tracking-[-0.015em] text-balance">
              The pursuit of <br className="hidden md:block" />
              <em className="not-italic text-gold-warm font-light">collective</em>
              <span className="text-paper-primary"> human potential.</span>
            </h1>

            <div className="mt-10 max-w-xl">
              <p className="text-paper-secondary text-lg md:text-xl leading-relaxed font-serif text-pretty">
                The study of the conditions that allow individuals, teams, organizations, and
                societies to become more than they otherwise would have been.
              </p>
            </div>

            <div className="mt-12 flex flex-wrap items-center gap-6 md:gap-10">
              <Link
                to="/thinking"
                data-testid="hero-cta-thinking"
                className="btn-arrow"
              >
                <span>Begin with the observations</span>
                <span className="arrow">→</span>
              </Link>
              <Link
                to="/about"
                data-testid="hero-cta-about"
                className="font-mono text-[11px] uppercase tracking-[0.22em] text-paper-secondary hover:text-paper-primary transition-colors duration-300 underline-offset-4 decoration-paper-mute hover:decoration-paper-primary underline"
              >
                Who is Quentin
              </Link>
            </div>
          </div>

          {/* Right: portrait */}
          <div className="lg:col-span-5 order-1 lg:order-2">
            <div className="relative">
              <div className="aspect-[4/5] w-full overflow-hidden border border-ink-line bg-ink-surface">
                <img
                  src={PORTRAITS.standing}
                  alt="Portrait of Quentin Young, standing by a window in a contemplative pose."
                  className="w-full h-full object-cover img-desaturate"
                  loading="eager"
                />
              </div>
              {/* Caption */}
              <div className="mt-4 flex items-start justify-between gap-4">
                <p className="eyebrow">Portrait No. 01, Standing</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-paper-mute">QY · 2026</p>
              </div>
              {/* Decorative compass */}
              <CompassMark
                size={120}
                opacity={0.06}
                className="absolute -right-10 -bottom-10 hidden lg:block pointer-events-none"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom rule + scroll hint */}
      <div className="container-wide">
        <div className="hairline" />
        <div className="flex items-center justify-between py-6">
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-paper-tertiary">
            Capture · Refine · Connect · Preserve
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-paper-tertiary">
            Scroll ↓
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
